angular.module('leanlaw').service('layoutService', function () {
  var service = {
    title: '',
    commands: '',
    navtemplate: '',
    actionTemplateL: '',
    actionTemplateR: '',
    main: $('.content-main'),
    navOffset: 30,
    hideNav: function () {
      this.navOffset = 30;
      this.scale();
    },
    showNav: function () {
      this.navOffset = 225;
      this.scale();
    },
    scale: function () {
      var width = $(window).width();
      this.main.css('margin-left', this.navOffset);
      this.main.width(width - this.navOffset - 30);
    },
    getTitle: function () {
      return this.title;
    }
  };
  $(window).resize(function () {
    service.scale();
  });
  service.hideNav();
  return service;
});
angular.module('leanlaw').service('pagingService', function () {
  var service = {
    currentPage: 1,
    totalRecords: 0,
    itemsPerPage: 15,
    show: function () {
      return this.totalRecords > 0;
    },
    from: function () {
      if (this.currentPage == 1) return 1;
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    to: function () {
      var to;
      if (this.currentPage == 1) {
        to = this.itemsPerPage;
      } else {
        to = this.from() + this.itemsPerPage;
      }
      if (to > this.totalRecords) {
        to = this.totalRecords;
      }
      return to;
    },
    showPrev: function () {
      return this.currentPage > 1;
    },
    showNext: function () {
      return this.currentPage != this.totalPages();
    },
    totalPages: function () {
      return Math.ceil(this.totalRecords / this.itemsPerPage);
    },
    setCurrentPage: function (page) {
      if (page < 1) {
        page = 1;
      }
      if (page > this.totalPages()) {
        page = this.totalPages();
      }
      this.currentPage = page;
    },
    prev: function () {
      this.setCurrentPage(this.currentPage - 1);
      if (this.changePageCb) {
        this.changePageCb(this.currentPage);
      }
    },
    next: function () {
      this.setCurrentPage(this.currentPage + 1);
      if (this.changePageCb) {
        this.changePageCb(this.currentPage);
      }
    },
    update: function () {
      if (this.updateCb) {
        this.updateCb();
      }
    },
    changePageCb: null,
    updateCb: null
  };
  return service;
});
angular.module('leanlaw').controller('ToolbarController', ['$scope', 'layoutService', function ($scope, layoutService) {
  $scope.$watch(function () {
    return layoutService.title;
  }, function (data) {
    $scope.title = data;
  }, true);
  $scope.$watch(function () {
    return layoutService.actionTemplateL;
  }, function (data) {
    $scope.actionTemplateL = data;
  }, true);
  $scope.$watch(function () {
    return layoutService.actionTemplateR;
  }, function (data) {
    $scope.actionTemplateR = data;
  }, true);
}]);
angular.module('leanlaw').controller('NavCtrl', ['$scope', 'layoutService', function ($scope, layoutService) {
  $scope.$watch(function () {
    return layoutService.navTemplate;
  }, function (data) {
    $scope.navTemplate = data;
    if (data != null) {
      layoutService.showNav();
    }
  }, true);
}]);
angular.module('leanlaw').controller('PagerCtrl', ['$scope', 'pagingService', function ($scope, pagingService) {
  pagingService.updateCb = function () {
    $scope.showPrev = pagingService.showPrev();
    $scope.showNext = pagingService.showNext();
    $scope.from = pagingService.from();
    $scope.to = pagingService.to();
    $scope.total = pagingService.totalRecords;
    $scope.show = pagingService.show();
  };
  $scope.next = function () {
    pagingService.next();
  };
  $scope.prev = function () {
    pagingService.prev();
  };
}]);
angular.module('leanlaw').controller('BackCtrl', ['$scope', '$location', function ($scope, $location) {
  $scope.back = function () {
    $location.path('/messages/');
  };
}]);
angular.module('leanlaw').controller('HeaderCtrl', ['$scope', '$rootScope', '$location', function ($scope, $rootScope, $location) {
  $scope.isActive = function (viewLocation) {
    var active = $location.path().indexOf(viewLocation) > -1;
    return active;
  };
}]);